import { InfiniteData, useMutation, useQueryClient } from "@tanstack/react-query";
import { makeCRMApi } from "../CrmApi";
import { IChangeNotificationStatusRequest, INotification, INotificationSearchResponse } from "../types/NotificationTypes";
import { AxiosResponse } from "axios";

export const useNotificationMarkRead = () => {
  const crmApi = makeCRMApi();
  const queryClient = useQueryClient();
  
  const notificationMarkReadMutation = useMutation({
    mutationKey: ['crm-notification-mark-read'],
    mutationFn: (data: IChangeNotificationStatusRequest) => crmApi.markNotificationRead(data.notificationId, data.read ?? false),
  });
  
  return notificationMarkReadMutation;
}
